var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _vm.rawData.game_mark.indexOf("yjfm") == -1
        ? _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("dataScreening", {
                attrs: {
                  propsData: {
                    isCountry: false,
                    isCurrency: false,
                    adPlacement: false,
                    adChannel: false,
                    isDate: false
                  }
                },
                on: {
                  searchChange: _vm.searchChange,
                  currencyChange: _vm.currencyChange
                }
              }),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      on: { change: _vm.getServer },
                      model: {
                        value: _vm.paramsData.is_prod,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "is_prod", $$v)
                        },
                        expression: "paramsData.is_prod"
                      }
                    },
                    _vm._l(_vm.severlist, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelectServer")
                      },
                      on: { change: _vm.YjfmSeverChange },
                      model: {
                        value: _vm.paramsData.server_id,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "server_id", $$v)
                        },
                        expression: "paramsData.server_id"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.selectYjfmAll },
                          model: {
                            value: _vm.checked,
                            callback: function($$v) {
                              _vm.checked = $$v
                            },
                            expression: "checked"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("selectAll")))]
                      ),
                      _vm._l(_vm.serverList, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("dataScreening", {
                attrs: {
                  propsData: {
                    isCountry: false,
                    isCurrency: false,
                    adPlacement: false,
                    adChannel: false,
                    isDate: false
                  }
                },
                on: {
                  searchChange: _vm.searchChange,
                  currencyChange: _vm.currencyChange
                }
              }),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      on: { change: _vm.envIdChange },
                      model: {
                        value: _vm.paramsData.env_id,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "env_id", $$v)
                        },
                        expression: "paramsData.env_id"
                      }
                    },
                    _vm._l(_vm.szgmEnv, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: _vm.$t("serverChannel")
                      },
                      on: { change: _vm.serverChange },
                      model: {
                        value: _vm.server_channel,
                        callback: function($$v) {
                          _vm.server_channel = $$v
                        },
                        expression: "server_channel"
                      }
                    },
                    _vm._l(_vm.serverChannel, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("showTestServer")
                      },
                      on: { change: _vm.serverChannelChange },
                      model: {
                        value: _vm.show_test,
                        callback: function($$v) {
                          _vm.show_test = $$v
                        },
                        expression: "show_test"
                      }
                    },
                    _vm._l(_vm.serverType, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        filterable: "",
                        placeholder: _vm.$t("server")
                      },
                      on: { change: _vm.severChange },
                      model: {
                        value: _vm.paramsData.server_id,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "server_id", $$v)
                        },
                        expression: "paramsData.server_id"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.selectAll },
                          model: {
                            value: _vm.checked,
                            callback: function($$v) {
                              _vm.checked = $$v
                            },
                            expression: "checked"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("selectAll")))]
                      ),
                      _vm._l(_vm.serverListYJ, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.exportdataloading,
                    disabled: !_vm.tableData.length
                  },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut ", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "sticky-table-header",
              rawName: "v-sticky-table-header",
              value: 0,
              expression: "0"
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          ref: "tableRef",
          attrs: { id: "tableRef", data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "game", label: _vm.$t("game") }
          }),
          _c("el-table-column", {
            attrs: { prop: "platform", label: _vm.$t("platform") }
          }),
          _c("el-table-column", {
            attrs: { prop: "channel", label: _vm.$t("channel") }
          }),
          _c("el-table-column", {
            attrs: { prop: "pkg", label: _vm.$t("pkg") }
          }),
          _c("el-table-column", {
            attrs: { prop: "ad_channel", label: _vm.$t("adChannel") }
          }),
          _c("el-table-column", {
            attrs: { prop: "ad_placement", label: _vm.$t("adPlacement") }
          }),
          _c("el-table-column", {
            attrs: { prop: "task", label: _vm.$t("levelLabel") }
          }),
          _c("el-table-column", {
            attrs: { prop: "user_id", label: "user_id" }
          }),
          _c("el-table-column", {
            attrs: { prop: "role_id", label: _vm.$t("roleId") }
          }),
          _c("el-table-column", {
            attrs: { prop: "time", label: _vm.$t("time") }
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            staticStyle: { "text-align": "center" },
            attrs: {
              layout: "total,sizes, prev, pager, next",
              "current-page": _vm.searchData.page,
              total: _vm.total
            },
            on: {
              "size-change": _vm.sizeChange,
              "current-change": _vm.searchClick
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }